// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"791":"683a78b2ba8de5f6","6085":"5659a47a7c3bf2fb"}[chunkId] + ".css";
};